import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '@/views/HomeView.vue'
import ER404 from '@/components/Errors/404'
import Planner__Schedule from '@/views/planner/Schedule'
import reportCreate from "@/views/reports/create/reportCreate"
import reportShow from "@/views/reports/viewer/reportShow"
import reportEditor from "@/views/reports/editor/reportEditor"
import DB__TV from "@/views/dashboard/TV-App.vue"
import ProductivityApp from "@/views/dashboard/productivityApp.vue"
import A_Planner_DS from "@/views/a_planner/A_Planner_DS.vue"
import A_Planner_Y from "@/views/a_planner/A_Planner_Y.vue"
import A_Planner_Q from "@/views/a_planner/A_Planner_Q.vue"
import ErrorPage from "@/views/ErrorPage.vue"
import StatsBoard from "@/views/dashboard/StatsBoard.vue";
import EditorView from "@/views/wp_planner/Editor.vue";
import PrinterView from "@/views/wp_planner/Printer.vue";
import WP_Handler from "@/views/wp_planner/Handler.vue";
import SelectDistrict from "@/views/wp_planner/SelectDistrict.vue";
import RedirectToSelect from "@/views/wp_planner/RedirectToSelect.vue";

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/planner',
    name: 'planner__home',
    children: [
      {
        path: '/planner/schedule',
        name: 'planner__schedule',
        component: Planner__Schedule,
      }
    ]
  },
  {
    path: '/autoplanner',
    name: 'a__planner__home',
    children: [
      {
        path: '/autoplanner/district',
        name: 'a__planner__district',
        component: A_Planner_DS,
      },
      {
        path: '/autoplanner/y/:guid?/:year?',
        props: true,
        name: 'a__planner__y',
        component: A_Planner_Y,
      },
      {
        path: '/autoplanner/q/:guid?/:year?/:quarter?',
        props: true,
        name: 'a__planner__q',
        component: A_Planner_Q,
      }
    ]
  },
  {
    path: '/operate',
    name: 'wp__home',
    component: WP_Handler,
    children: [
      {
        path: '',
        name: 'wp_redirect',
        component: RedirectToSelect,
      },
      {
        path: 'select',
        name: 'wp__select',
        component: SelectDistrict,
      },
      {
        path: 'edit/:district',
        name: 'wp__edit',
        props: true,
        component: EditorView,
      },
      {
        path: 'edit',
        component: RedirectToSelect,
      },
      {
        path: 'print/:district',
        name: 'wp__print',
        props: true,
        component: PrinterView,
      },
      {
        path: 'print',
        component: RedirectToSelect,
      }
    ],
  },
  {
    path: '/report',
    name: 'report',
    children: [
      {
        path: '/report/create',
        name: 'report__create',
        component: reportCreate,
      },
      {
        path: '/report/editor',
        name: 'report__editor',
        component: reportEditor,
      },
      {
        path: '/report/show',
        name: 'report__show',
        component: reportShow,
      }
    ]
  },
  {
    path: '/dashboard',
    name: 'dashboard',
    children: [
      {
        path: '/dashboard/tv',
        name: 'dashboard__tv',
        component: DB__TV,
      },
      {
        path: '/dashboard/productivity',
        name: 'productivity',
        component: ProductivityApp,
      },
      {
        path: '/dashboard/district_stats',
        name: 'district_stats',
        component: StatsBoard,
      }
    ]
  },
  {
    path: '/error',
    name: 'error',
    beforeEnter: (to, from, next) => {
      if (to.query.reason) {
        next()
      } else {
        next({name: 'error', query: { reason: '1' } })
      }
    },
    component: ErrorPage,
  },
  {
    // path: "*",
    path: "/:catchAll(.*)",
    name: "NotFound",
    component: ER404,
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
